import { createFileRoute } from '@tanstack/react-router';
import React from 'react';

import DebugNewGameRoute from '~/debug/DebugNewGameRoute';

export const Route = createFileRoute('/debug/newgame/$snapshotId')({
  component: DebugNewGameRouteWrapper,
});

function DebugNewGameRouteWrapper() {
  const { snapshotId } = Route.useParams();
  return <DebugNewGameRoute snapshotIdParam={snapshotId} />;
}
